import * as types from './actionTypes';
import * as api from '../../../common/api';
import { getSearchCriteria } from './selectors';

export const customerLookupCall = searchCriteria => ({
    types: [ types.CUSTOMER_LOOKUP_REQUEST, types.CUSTOMER_LOOKUP_SUCCESS, types.CUSTOMER_LOOKUP_FAILURE ],
    apiCall: () => api.customerLookup(searchCriteria),
});

export const customerLookup = (dispatch, getState) => {
     const state = getState();
     const searchCriteria = getSearchCriteria(state);
     return dispatch(customerLookupCall(searchCriteria));
};


export const changeSearchCriteria = (field, value) => ({
    type: types.CHANGE_FIELD,
    field,
    value
});

export const blurSearchCriteria = (field, value) => ({
    type: types.BLUR_FIELD,
    field,
    value
});

export const clearSearchCriteria = ({
    type: types.CLEAR_CRITERIA,    
});
